import RemoteConnection from '@/models/RemoteConnection'
import WebMessage from '@/models/WebMessage'
import router from '@/Routes'

export default [
  // {
  //   key: 'checkbox',
  //   sortable: false,
  //   class: 'text-center align-middle text-capitalize',
  //   show: true,
  //   type: 'checkbox',
  // },
  {
    key: 'name',
    label: 'Name',
    sortable: true,
    class: 'text-center align-middle text-capitalize',
    show: true,
  },
  {
    key: 'code',
    label: 'Code',
    sortable: true,
    class: 'text-center align-middle  ',
    show: true,
    formatter: (value: string) => value.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
  },
  {
    key: 'driver',
    label: 'Driver',
    sortable: true,
    class: 'text-center align-middle text-capitalize',
    show: true,
  },
  {
    key: 'network_id',
    label: 'Network id',
    sortable: true,
    class: 'text-center align-middle text-capitalize',
    show: true,
  },
  {
    key: 'type',
    label: 'Type',
    sortable: true,
    class: 'text-center align-middle text-capitalize',
    show: true,
    formatter: (value: string) => value.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
  },
  {
    key: 'action',
    label: 'Actions',
    filter: false,
    sortable: false,
    show: true,
    class: 'text-center align-middle text-capitalize',
    type: 'action',
    thStyle: { width: '160px' },
    actions: [
      {
        icon: 'eye',
        title: 'Edit',
        event: 'edit',
        top_level: true,
        action: (remoteCon: RemoteConnection) => {
          router.push({ name: 'remote-connection', params: { id: remoteCon.id } })
        },
      },
      {
        icon: 'trash',
        title: 'Delete',
        event: 'delete',
        action: (remoteCon: RemoteConnection, dataTable: any) => {
          WebMessage.confirm(
            `Are you sure that you want to delete the ${remoteCon.name} connection?`,
            'Delete Opportunity',
            { okTitle: 'Delete' },
          ).then((response: any) => {
            if (response) {
              remoteCon.delete().then(() => {
                dataTable.refresh()
              })
            }
          })
        },
      },
    ],
  },
]
